import {
  LOCALIZATION_SET_SYSTEM_UNIT,
  LOCALIZATION_SET_ACTIVE_LANGUAGE,
  LOCALIZATION_SET_ACTIVE_REGION
} from "../lib/types";

export const setActiveRegion = ( regionId ) => ( dispatch ) => {
  dispatch({
    type: LOCALIZATION_SET_ACTIVE_REGION,
    payload: regionId
  });
};

export const setActiveLanguage = ( languageId ) => ( dispatch ) => {
  dispatch({
    type: LOCALIZATION_SET_ACTIVE_LANGUAGE,
    payload: languageId
  });
};

export const setSystemUnit = ( unit ) => ( dispatch ) => {
  dispatch({
    type: LOCALIZATION_SET_SYSTEM_UNIT,
    payload: unit
  });
};



// WEBPACK FOOTER //
// ./src/actions/localization-actions.js